"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _sharedInputStyles = require("./sharedInputStyles");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), _sharedInputStyles.wrapperStyles);

var StyledPrefix = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0 0.5rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledReadOnly = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), _sharedInputStyles.inputStyles);

var StyledInput = _styledComponents.default.input(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), _sharedInputStyles.inputStyles, function (p) {
  return p.theme.colorLabel;
});

var FormTextboxDebounce = function FormTextboxDebounce(_ref) {
  var disabled = _ref.disabled,
      name = _ref.name,
      type = _ref.type,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      autoFocus = _ref.autoFocus,
      isError = _ref.isError,
      isReadOnly = _ref.isReadOnly,
      prefix = _ref.prefix;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = _slicedToArray(_useState3, 2),
      realValue = _useState4[0],
      setRealValue = _useState4[1];

  var debouncedFunc = (0, _lodash.debounce)(function () {
    return console.log("debounce");
  }, 1000, {
    leading: false,
    trailing: true
  });

  var handleFocused = function handleFocused() {
    setFocused(true);
    onFocus();
  };

  var handleBlurred = function handleBlurred(e) {
    setFocused(false);
    onBlur(e);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    isFocused: isFocused,
    isError: isError,
    children: [prefix && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPrefix, {
      children: prefix
    }), isReadOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledReadOnly, {
      children: value
    }), !isReadOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInput, {
      autoFocus: autoFocus,
      value: realValue,
      name: name,
      onChange: function onChange(e) {
        //onChange(e);
        setRealValue(e.target.value); //throttledFunc();

        debouncedFunc(); //throttledFunc();
        // throttledFunc();
        //sendTextChange(e);
      },
      onFocus: handleFocused,
      onBlur: handleBlurred,
      type: type,
      placeholder: placeholder
    })]
  });
};

FormTextboxDebounce.defaultProps = {
  type: "text",
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  }
};
FormTextboxDebounce.propTypes = {
  disabled: _propTypes.default.bool,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  placeholder: _propTypes.default.string
};
var _default = FormTextboxDebounce;
exports.default = _default;